<div class="ib-campaign-list__IB card bg-dark-lighter text-white mb-3" >
  <div class="card-body">
    <div class="row mb-3 fs-15 d-flex justify-content-between align-items-center">
      <div class="col-md-5">
        {{type == 'campaignIb'?'IB campaign':'User campaign'}}
      </div>
      <div class="col-md-7 d-flex justify-content-end align-items-center">
        <div class="campaign__calendar d-inline-block">
          <span class="text ml-2">Start Time</span>
          <p-calendar
            name="ib_campaign_start"
            [(ngModel)]="startTime"
            [placeholder]="'dd/mm/yyyy HH:mm:ss'"
            [dateFormat]="'dd/mm/yy'"
            [timeOnly]="false"
            [showIcon]="true"
            [showSeconds]="true"
            [showTime]="true"
            inputStyleClass="form-control"
          ></p-calendar>
          <span class="calender-time"></span>
        </div>
        <div class="campaign__calendar  d-inline-block" >
          <span class="text ml-2">End Time</span>
          <p-calendar
            name="ib_campaign_end"
            [(ngModel)]="endTime"
            [placeholder]="'dd/mm/yyyy HH:mm:ss'"
            [dateFormat]="'dd/mm/yy'"
            [timeOnly]="false"
            [showSeconds]="true"
            [showIcon]="true"
            [showTime]="true"
            inputStyleClass="form-control"
          ></p-calendar>
          <span class="calender-time"></span>
        </div>
        <div class="campaign__btn d-inline-block ml-2 ">
          <button 
            class="btn btn-main mr-2 campaign__btn-apply" 
            type="button" (click)="search()"
            [disabled]="!startTime || !endTime"
            >
            Apply
          </button>
          <button class="btn btn-main" type="button" (click)="refresh()">
            Refresh
          </button>
        </div>
      </div>
    </div>
    <div class="table-responsive" *ngIf="type == 'campaignIb'">
      <table class="rox-table table table-bordered">
        <thead>
          <tr>
            <th class="text-center">Period</th>
            <th class="text-center">Campaign ID</th>
            <th class="text-center">Campaign Name</th>
            <th class="text-center">Type</th>
<!--            <th class="text-center">Status</th>-->
            <!-- <th class="text-center">Sub-IB rate</th> -->
            <th class="text-center">Sub-IB</th>
            <th class="text-end">Total </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of data; let i = index">
            <td class="text-center">{{ item.create_time | date: 'yyyy/MM' }}</td>
            <td class="text-center">{{ item.id }}</td>
            <td class="text-center">{{ item.description }}</td>
            <td class="text-center">{{ 'IB' }}</td>
<!--            <td class="text-center">-->
<!--              <span class="text-red" *ngIf="item.status == 0">Close</span>-->
<!--              <span class="" *ngIf="item.status != 0">Ongoing</span>-->
<!--            </td>-->
            <!-- <td class="text-center">{{ item.data.rate * 100 }} %</td> -->
            <td class="text-center">{{ item.sub_ib_number }}</td>
            <td class="text-end"> 
              $ {{item.real_account.affiliate_return |DecimalPipe:"1.2-2"}}
              <!-- <span labelNumber="{{item.real_account.affiliate_return}}" [currency]="currency"></span> -->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="table-responsive" *ngIf="type == 'campaignUser'">
      <table class="rox-table table table-bordered">
        <thead>
        <tr>
          <th class="text-center">Period</th>
          <th class="text-center">Campaign ID</th>
          <th class="text-center">Campaign Name</th>
          <th class="text-center">Type</th>
<!--          <th class="text-center">Status</th>-->
          <th class="text-center">User Account</th>
          <th class="text-end">Lots</th>
          <th class="text-end">Lot Rebate </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of data; let i = index">
          <td class="text-center">{{ item.create_time | date: 'yyyy/MM' }}</td>
          <td class="text-center">{{ item.id }}</td>
          <td class="text-center">{{ item.description }}</td>
          <td class="text-center">{{ 'User' }}</td>
<!--          <td class="text-center">-->
<!--            <span class="text-red" *ngIf="item.status == 0">Close</span>-->
<!--            <span class="" *ngIf="item.status != 0">Ongoing</span>-->
<!--          </td>-->
          <td class="text-center">{{ item.user_number | number }}</td>
          <td class="text-end">{{ item.real_account.total_lot | number }}</td>
          <td class="text-end">
            <!-- <span labelNumber="{{item.real_account.affiliate_return}}" [currency]="currency"></span> -->
            <span>
              $ {{item.real_account.affiliate_return |DecimalPipe:"1.2-2"}}
            </span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>


  
 
